/*! Copyright 2025 Lane Crawford, All Rights Reserved. */


/* eslint */

/**
 * A component for binding google/baidu maps
 * to an area on the page
 */
( function( LC, $ ) {

	"use strict";

	// initialise the components object,
	// if it doesn't already exist.
	LC.Components = LC.Components || {};

	// initialise the Map component constructor,
	// used for prototyping lcMaps.
	LC.Components.Map = function( $el, region, options ) {

		var _this = this;
		_this.initialised = false;
		_this.canInitialise = true;
		_this.instanceId = _.uniqueId( _this.namespace + "_" );

		// we can't do anything without a valid
		// element to initialise on.
		if ( !$el || !$el.length ) {
			LC.warn( "cannot initialise a 'Map' without an element." );
			_this.canInitialise = false;
		}

		if ( !region || typeof region !== "string" ) {
			LC.warn( "cannot initialise a 'Map' without an region." );
			_this.canInitialise = false;
		}

		/**
		 * Default options for the map component
		 * @type {Object}
		 */
		_this.defaults = {
			clickableIcons: false,
			marker: {
				url: LC.asset( "img/map/marker.png" ),
				origin: { x: 0, y: 0 },
				anchor: { x: 10, y: 26 },
				size: { x: 26, y: 26 }
			},
			infoWindow: {
				maxWidth: 260,
				maxHeight: 130
			}
		};
		_this.options = $.extend( true, {}, _this.defaults, options );
		_this.region = region;

		// element caching
		_this.$map = $el;
		_this.$body = $("body");

		LC.pubsub.on( "MapProviderHasLoaded." + _this.instanceId, function() {
			_this.initMap();
		});

		return _this;

	};

	// some variables for making access easier.
	var _proto = LC.Components.Map.prototype;
	_proto.providers = {
		baidu: {},
		google: {}
	};

	_proto.googleScript = LC.config.getValue("url.maps.google");
	_proto.baiduScript = LC.config.getValue("url.maps.baidu");
	_proto.namespace =  "lcMap";

	/**
	 * initialise the component
	 */
	_proto.init = function() {

		var _this = this;

		/**
		 * set the provider as baidu/google
		 */
		_this.setProvider();

		// don't get the <script> from provider
		// if it's already loaded; this is because google/baidu
		// will give an error and potentially cause problems
		// if the script is loaded twice.
		if ( !window.lcMapLoaded ) {

			_this.getScript()

				.done( function() {

					_this.successScript();
					_this.initialClasses();

				} )

				.fail( _this.failScript );

		} else {

			// use a timeout to force async
			// firing on the trigger. This is to
			// allow any modules that need to listen
			// to set up their listener.
			setTimeout(function() {

				_this.duplicateScript();
				_this.initialClasses();
				_this.triggerInit();

			}, 50 );

		}
	};

	/**
	 * set some initial css classes on elements
	 */
	_proto.initialClasses = function() {

		this.$map.addClass("lc-map");

	};

	/**
	 * simple check to see if we're in
	 * china or not.
	 * @return {Boolean} | In China?
	 */
	_proto.isChina = function() {

		return this.region === "CN";

	};

	/**
	 * get the correct region specific map script and add it
	 * to the dom then return the defered object
	 * @return {$.Deferred} [ allows us to lazily execute initialisation ]
	 */
	_proto.getScript = function() {

		var _this = this,
			mapScript;

		if ( _this.isChina() ) {

			// use the script for baidu in china
			mapScript = _this.baiduScript;

		} else {

			// use the script for google otherwise
			mapScript = _this.googleScript;

		}

		// add the "callback" method we want to trigger after setup
		mapScript += "&callback=LC.Components.Map.prototype.triggerInit";

		// return the deferred to enable fail()/done() methods
		return $.getScript( mapScript );

	};

	/**
	 * set the provider for this instance to whichever
	 * country was provided in teh "region" option. This
	 * basically just aliases the "_this.provider" correctly
	 * so we never need to do a conditional when re-routing
	 * methods to the provider.
	 */
	_proto.setProvider = function() {

		var _this = this;

		if ( _this.isChina() ) {

			_this.provider = _this.providers.baidu;

		} else {

			_this.provider = _this.providers.google;

		}

	};

	/**
	 * triggerInit() is needed because the map
	 * providers use a "callback" function to communication
	 * that they've finished executing the map core
	 */
	_proto.triggerInit = function() {

		// when the map runs for the first time
		// there is no way to get the instance
		// because the "this" context is bound to
		// the provider map service. So the first map's
		// event listener instanceId should be empty.
		// Any second/subsequent events will use the
		// instanceId.
		var instance = this.instanceId ? "." + this.instanceId : "";

		// trigger a global event for use if we ever
		// need to handle a map init event.
		LC.pubsub.trigger( "MapProviderHasLoaded" + instance );

	};

	/**
	 * initialise the map instance
	 */
	_proto.initMap = function() {

		this.createMap();

		this.initialised = true;
		this.$map.trigger( "init.map", this );

	};

	/**
	 * Simple log for when the script
	 * fails to load for any reason!
	 */
	_proto.failScript = function() {

		LC.error( "map script failed to load for: " + this.region );

	};

	/**
	 * Simple log and boolean setting for after
	 * the script is successfully loaded.
	 */
	_proto.successScript = function() {

		// set a boolean to indicate that the
		// map script has already been run in the
		// browser
		window.lcMapLoaded = true;

		LC.info( "map script loaded successfully for: " + this.region );

	};

	/**
	 * simple log to indicate the script was already
	 * loaded previously and won't load again this time.
	 */
	_proto.duplicateScript = function() {

		LC.info( "map script previously loaded for: " + this.region );

	};

	/**
	 * create the map inside of the _this.$map container
	 */
	_proto.createMap = function() {

		var _this = this;

		// save the original content before
		// we delete it, so we can replace in destroy();
		_this.originalContent = _this.$map.clone( true, true );

		// if there's any content in the element,
		// remove it so we don't get conflicts with the map
		_this.$map.empty();

		// use $.proxy() to pass the correct "this" context
		// to the "createMap" method in the provider. We use proxy
		// because otherwise "this" would be the prototype instead
		// of the current instance.
		$.proxy( _this.provider.createMap, _this )();
		_this.addZoomControls();

	};

	/**
	 * method for adding the +/- zoom
	 * controls to the current map
	 */
	_proto.addZoomControls = function() {

		var _this = this,
			$wrapper,
			$button,
			$zoomIn,
			$zoomOut;

		$wrapper =
			$("<div class=\"lc-map__zoom / pos-a t-10 l-10\" />");

		// button has some horizontal borders
		// to make it the same height/width.
		$button =
			$("<button " +
				"type=\"button\"" +
				"class=\"lc-icon lc-map__zoom / bg-white bor-white bor-h2 / opc-80 / cur-p " +
						"txt-24 txt-black txt-c / disp-b pad-10 / mar-b2 / an-short\" />");

		$zoomIn =
			$button
				.clone()
				.addClass("lc-map__zoom-in")
				.attr("data-icon", "plus")
				.on("click", $.proxy( _this.zoomIn, _this ) );

		$zoomOut =
			$button
				.clone()
				.addClass("lc-map__zoom-out")
				.attr("data-icon", "minus")
				.css("top", "68px")
				.on("click", $.proxy( _this.zoomOut, _this ) );

		$wrapper.append( $zoomIn, $zoomOut );
		_this.$map.append( $wrapper );

	};

	/**
	 * pan the map to the given coordinates
	 * @param {Object} location | Coords to pan to
	 *                          | eg: { "latitidue": 36.300, "longitude": 100.100 }
	 */
	_proto.panTo = function( location ) {

		var _this = this,
			isValid = _this.locationIsValid( location );

		if ( isValid ) {

			// use $.proxy() to pass the correct "this" context
			// to the "panTO" method in the provider. We use proxy
			// because otherwise "this" would be the prototype instead
			// of the current instance.
			$.proxy( _this.provider.panTo, _this, location )();


		} else {

			LC.warn( "Invalid latitude / longitude" );

		}

	};

	/**
	 * set the map's zoom level to the given
	 * input parameter
	 * @param  {Integer} level | level to zoom to
	 *                         | eg: 10
	 */
	_proto.zoomTo = function( level ) {

		var _this = this,
			isValid,
			isDefault;

		isValid = Number.isInteger( level );
		isDefault = ( typeof level === "undefined" );

		if ( isValid || isDefault ) {

			// use $.proxy() to pass the correct "this" context
			// to the "zoomTo" method in the provider. We use proxy
			// because otherwise "this" would be the prototype instead
			// of the current instance.
			$.proxy( _this.provider.zoomTo, _this, level )();

		} else {

			LC.warn( "Zoom Level parameter is invalid" );

		}

	};

	/**
	 * zoom in.
	 */
	_proto.zoomIn = function() {

		var _this = this,
			newZoom = _this.map.getZoom() + 1;

		$.proxy( _this.provider.zoomTo, _this, newZoom )();

	};

	/**
	 * zoom out.
	 */
	_proto.zoomOut = function() {

		var _this = this,
			newZoom = _this.map.getZoom() - 1;

		$.proxy( _this.provider.zoomTo, _this, newZoom )();

	};

	/**
	 * method to pan and zoom to a location on the map
	 * this is needed because Baidu has problems with
	 * running pan/zoom at the same time.
	 *
	 * @param {Object} location | Coords to pan to
	 *                          | eg: { "latitidue": 36.300, "longitude": 100.100 }
	 * @param {Integer} level 	| level to zoom to
	 *                          | eg: 10
	 */
	_proto.panAndZoomTo = function( location, level ) {

		var _this = this,
			locationIsValid = _this.locationIsValid( location ),
			levelIsValid = Number.isInteger( level ),
			levelIsDefault = ( typeof level === "undefined" );

		if ( locationIsValid ) {

			if ( levelIsValid || levelIsDefault ) {

				$.proxy( _this.provider.panAndZoomTo, _this, location, level )();

			} else {

				LC.warn( "Zoom Level parameter is invalid" );

			}

		} else {

			LC.warn( "Invalid latitude / longitude" );

		}

	};

	/**
	 * method to determine in an object is a valid
	 * set of coordinates to use with pan/marker functions
	 *
	 * @param  {Object} location | object containing latitude/longitude
	 *                           | eg: { "latitidue": 36.300, "longitude": 100.100 }
	 * @return {Boolean}      	 | is the location valid
	 */
	_proto.locationIsValid = function( location ) {

		var result = false,
			locationKeys = _.keys( location );

		if (
			_.includes( locationKeys, "latitude" ) &&
			_.includes( locationKeys, "longitude" ) &&
			Number.isFloat( location.latitude ) &&
			Number.isFloat( location.longitude )
		) {

			result = true;

		}

		return result;
	};

	/**
	 * create a marker at a specific location and
	 * add it to the map. Actually defers to the provider's
	 * "createMarker" method
	 * @param  {Object} location   | location object with latitude/longitude
	 * @param  {Object} iconObject | icon object as defined like the defaults.marker
	 * @param  {String} name       | name to apply to the marker (for future access)
	 * @param  {String} priority   | the priority of the marker (lower = more priority)
	 * @return {Object}            | return the map-provider's marker object
	 */
	_proto.createMarker = function( location, iconObject, name, priority ) {

		var _this = this,
			marker;

		if ( !location ) {

			LC.warn( "Cannot create marker without location" );
			return false;

		}

		marker = $.proxy( _this.provider.createMarker, _this, location, iconObject, priority )();

		// Store the newly created marker in an object
		// This object is for binding events and connecting
		// info window and also delete marker if needed.
		name = name || _.uniqueId( "marker_" );
		_this.markers = _this.markers || {};

		_this.markers[ name ] = marker;

		return marker;

	};

	/**
	 * create an infowindow for opening later
	 * @param  {string} content   	| string with the html content to show in the infoWindow
	 * @param  {String} name       	| name to apply to the infoWindow (for future access)
	 * @param  {Object} options     | Object with options properties for info window.
	 * @return {Object}            	| return the map-provider's infoWindow object
	 */
	_proto.createInfoWindow = function( content, name, options ) {

		var _this = this,
			infoWindow,
			closeButton;

		if ( !content ) {

			LC.warn( "Cannot create info window without content" );
			return false;

		}

		closeButton =
			"<button " +
				"class=\"info-window__close / lc-icon / cur-p pos-a disp-ib pad-10 t-0 r-0\"" +
				"data-icon=\"close\" />" +
			"</button>";

		content += closeButton;

		infoWindow = $.proxy( _this.provider.createInfoWindow, _this, content, options )();

		// Store the newly info window in an object
		// This object is for binding events and connecting
		// info window and also delete info window if needed.
		name = name || _.uniqueId( "info_" );
		_this.infoWindows = _this.infoWindows || {};

		_this.infoWindows[ name ] = infoWindow;

		return infoWindow;

	};


	/**
	 * method for binding the click event on the
	 * open infoWindow's close (x) button
	 */
	_proto.bindCloseButton = function() {

		var _this = this,
			$button = $(".info-window__close");

		$button
			.off(".closeInfoWindow")
			.on("click.closeInfoWindow", function() {
				$.proxy( _this.closeInfoWindow, _this )();
			});

	};

	/**
	 * bind the click event on marker
	 * @param  {Object} infoWindow | object which comes from _this.infoWindows;
	 * @param  {marker} marker     | object which comes from _this.markers;
	 */
	_proto.bindClickMarkerEvent = function( data ) {

		var _this = this,
			marker = data.marker,
			infoWindow = data.infoWindow,
			callback = data.callback;

		if ( !marker ) {

			LC.error( "cannot bind action with no 'marker' parameter" );
			return false;

		}

		if ( !typeof callback === "function" || !callback ) {

			if ( !infoWindow ) {

				LC.error( "the default callback cannot run with no 'info window'" );
				return false;

			} else {

				callback = _this.openInfoWindow;

			}

		}

		$.proxy( _this.provider.bindClickMarkerEvent, _this, infoWindow, marker, callback )();

		return false;

	};

	/**
	 * method to open a specific info window at a marker's
	 * position on the map. (defers to the provider's method);
	 * @param  {object} infoWindow | object which comes from _this.infoWindows;
	 * @param  {object} marker     | object which comes from _this.markers;
	 * @return {object}            | returns the infoWindow which was opened.
	 */
	_proto.openInfoWindow = function( infoWindow, marker ) {

		var _this = this,
			openedWindow;

		if ( !infoWindow || !marker ) {

			LC.error( "cannot open infoWindow with no 'infoWindow' or 'marker' parameter" );
			return false;

		}

		// we only want to be showing one
		// infoWindow at a time, and we don't want
		// to keep old windows open when we open a new
		// window. So we close all other infoWindows.
		//
		// (only run if there are windows
		// in the _this.infoWindows object)
		if ( _.size( _this.infoWindows ) > 1 ) {

			_this.closeInfoWindow();

		}

		openedWindow = $.proxy( _this.provider.openInfoWindow, _this, infoWindow, marker )();

		setTimeout(function() {
			_this.bindCloseButton();
		}, 10);

		return openedWindow;

	};

	/**
	 * close the infoWindow which is passed as parameter
	 * (mostly useful for binding to the "x" button)
	 * @param  {object} infoWindow | (optional) object which comes from _this.infoWindows;
	 */
	_proto.closeInfoWindow = function( infoWindow ) {

		var _this = this;

		if ( !infoWindow ) {

			LC.info( "closing all infoWindows" );

		}

		$.proxy( _this.provider.closeInfoWindow, _this, infoWindow )();

	};

	/**
	 * destroy the map
	 */
	_proto.destroy = function() {

		var _this = this;

		// remove the bound init listener so that
		// we don't accidentally re-init every time
		// a map is loaded.
		LC.pubsub.off( "MapProviderHasLoaded." + _this.instanceId );

		// set the dom element back to original
		// and then remove the map data.
		// unbind all events.
		_this.originalContent
			.removeData("lcMap");

		_this.$map
			.replaceWith( _this.originalContent );

		// clear out the map instance
		// so there's no reference. This
		// should allow garbage collection to
		// handle it's stuff.
		_this = null;

	};


	/**
	 * Use a $.fn... binding to apply this component
	 * directly to a DOM element.
	 * @param  { String } region  	| CN / something else.
	 * @param  { Object } options  	| Object with options properties.
	 * @return { $ }         		| returns the jQuery chainable.
	 */
	$.fn.lcMap = function( region, options ) {

		var $this = $( this );

		return $this.each( function( k, el ) {

			var $el = $( el ),
				map;

			// check the given element's data object
			// to see if it already has a map initialised.
			// We don't want to re-initialise a map that
			// already is set up.
			if ( $el.data("lcMap") && $el.data("lcMap").initialised ) {

				LC.warn( "Map already initialised on that Dom Element. Not Initialising." );

			} else {

				// assign the prototype to a data-attribute for
				// access later on.
				map = new LC.Components.Map( $el, region, options );

				if ( !map.initialised && map.canInitialise ) {

					$el.data( "lcMap", map );
					map.init();

				}

			}

		});

	};

}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";


	// some variables for making access easier.
	var _proto = LC.Components.Map.prototype,
		_google = _proto.providers.google;

	_google.defaults = {
		center: [ 22.276577, 114.169235 ],
		zoom: 12,
		zoomTo: 17,
		infoWindow: {
			disableAutoPan: true
		},
		mapStyle: function() {

			return [

				{
					featureType: "administrative.neighborhood",
					stylers: [
						{ visibility: "on" }
					]
				}, {
					stylers: [
						{ saturation: -100 }
					]
				}, {
					featureType: "water",
					stylers: [
						{ visibility: "on" },
						{ hue: "#cecece" },
						{ saturation: 0 }
					]
				}, {
					featureType: "poi",
					stylers: [
						{ visibility: "off" }
					]
				}, {
					featureType: "transit",
					stylers: [
						{ visibility: "on" }
					]
				}, {
					featureType: "transit.line",
					elementType: "all",
					stylers: [
						{ visibility: "on" }
					]
				},
				{
					featureType: "transit.line",
					elementType: "labels.text",
					stylers: [
						{ visibility: "on" }
					]
				},
				{
					featureType: "transit.line",
					elementType: "labels.icon",
					stylers: [
						{ visibility: "on" }
					]
				},
				{
					featureType: "transit.station.rail",
					elementType: "labels.text",
					stylers: [
						{ visibility: "on" },
						{ lightness: "28" }
					]
				}, {
					featureType: "road.local",
					stylers: [
						{ visibility: "on" },
						{ lightness: 30 }
					]
				}, {
					featureType: "road.arterial",
					stylers: [
						{ visibility: "simplified" }
					]
				}, {
					featureType: "road.highway",
					stylers: [
						{ color: "#ffffff" },
						{ lightness: -3 },
						{ weight: 3.2 },
						{ visibility: "on" }
					]
				}, {
					featureType: "road.highway",
					elementType: "geometry.stroke",
					stylers: [
						{ weight: 1 },
						{ lightness: -20 }
					]
				}, {
					featureType: "road.highway",
					elementType: "labels",
					stylers: [
						{ visibility: "off" }
					]
				}, {
					featureType: "road.local",
					elementType: "labels",
					stylers: [
						{ visibility: "off" }
					]
				}, {
					featureType: "road",
					elementType: "labels.text",
					stylers: [
						{ visibility: "off" }
					]
				}, {
					featureType: "road.arterial",
					elementType: "labels",
					stylers: [
						{ visibility: "simplified" },
						{ lightness: "44" }
					]
				}, {
					featureType: "road",
					elementType: "labels.icon",
					stylers: [
						{ visibility: "off" }
					]
				}, {
					featureType: "landscape",
					stylers: [
						{ lightness: 30 }
					]
				}

			];

		}
	};

	_google.setDefaults = function() {

		var _this = this;

		_this.options = $.extend( true, {}, _google.defaults, _this.options );

	};

	/**
	 * method for creating the map inside the
	 * correct element on the page
	 *
	 */
	_google.createMap = function() {

		var _this = this,
			$map = _this.$map,
			center,
			mapStyle = _this.provider.defaults.mapStyle();

		// extend the default options with google default options
		$.proxy( _google.setDefaults, _this )();

		center = new google.maps.LatLng( _this.options.center[ 0 ], _this.options.center[ 1 ] );

		_this.map = new google.maps.Map(

			$map[ 0 ],

			{
				center: center,
				zoom: _this.options.zoom,
				clickableIcons: _this.options.clickableIcons
			}
		);

		_this.map.setOptions({
			styles: mapStyle
		});

		google.maps.event.addListener( _this.map, "click", function() {

			$.proxy( _this.closeInfoWindow, _this )();

		});

	};

	_google.createMarker = function( location, iconObject, priority ) {

		var _this = this,
			marker,
			markerIcon = _.extend( {}, _this.options.marker, iconObject ),
			markerOrigin = markerIcon.origin,
			markerAnchor = markerIcon.anchor,
			center = new google.maps.LatLng( location.latitude, location.longitude );

		priority = priority || 0;

		marker = new google.maps.Marker( {

			position: center,
			map: _this.map,
			icon: {
				url: markerIcon.url,
				origin: new google.maps.Point( markerOrigin.x, markerOrigin.y),
				anchor: new google.maps.Point( markerAnchor.x, markerAnchor.y)
			},
			zIndex: 10 + priority

		} );

		return marker;

	};

	_google.createInfoWindow = function( content, infoObject ) {

		var _this = this,
			infoWindow,
			infoSetting = _.extend( {}, _this.options.infoWindow, infoObject );

		infoWindow = new google.maps.InfoWindow( {

			content: content,
			maxWidth: infoSetting.maxWidth,
			maxHeight: infoSetting.maxheight,
			disableAutoPan: infoSetting.disableAutoPan

		} );

		return infoWindow;

	};

	_google.bindClickMarkerEvent = function( infoWindow, marker, callback ) {

		var _this = this;

		google.maps.event.addListener( marker, "click", function() {

			$.proxy( callback, _this, infoWindow, marker )();

		});

	};

	/**
	 * method to open a specific info window at a marker's
	 * position on the map.
	 * @param  {object} infoWindow | object which comes from _this.infoWindows;
	 * @param  {object} marker     | object which comes from _this.markers;
	 * @return {object}            | returns the infoWindow which was opened.
	 */
	_google.openInfoWindow = function( infoWindow, marker ) {

		var _this = this;

		infoWindow.open( _this.map, marker );

		setTimeout( function() {
			$.proxy( _this.provider.styleInfoWindow, _this )();
		}, 10);

		return infoWindow;

	};

	_google.styleInfoWindow = function() {

		var _this = this,
			$infoWindow;

		// the infoWindow element in google
		$infoWindow = _this.$map.find( ".gm-style-iw" );

		// add a class for the entire container
		$infoWindow
			.parent()
			.addClass( "info-window" );

		// add class for the styled background
		// so we can remove it with CSS.
		$infoWindow
			.prev()
			.addClass( "hide" );

		// hide the "x" button from google's
		// infowindow default view
		$infoWindow
			.next()
			.addClass( "hide" );

	};

	/**
	 * close the infoWindow which is passed as parameter,
	 * but google will loop through all windows if no
	 * "infoWindow" is passed.
	 * @param  {object} infoWindow | (optional) object which comes from _this.infoWindows;
	 */
	_google.closeInfoWindow = function( infoWindow ) {

		var _this = this;

		// if there's a passed in infoWindow,
		// then we just close the one passed.
		if ( infoWindow ) {

			infoWindow.close();

		} else {

			// but if no infoWindow is passed
			// then lets loop through all windows
			// and close them one-by-one
			_.each( _this.infoWindows, function( thisInfoWindow ) {

				thisInfoWindow.close();

			});

		}

	};

	/**
	 * method for pan the map to the desired location
	 * @param  {Object} location 	| object that contain latitude and longitude
	 */
	_google.panTo = function( location ) {

		var center;

		center = new google.maps.LatLng( location.latitude, location.longitude );
		this.map.panTo( center );

	};

	/**
	 * method for zoom in the map
	 * @param  {int} level 		| zoom value
	 */
	_google.zoomTo = function( level ) {

		var _this = this;

		level = level || _this.provider.defaults.zoomTo;
		_this.map.setZoom( level );

	};

	/**
	 * center the map on a specific location,
	 * and zoom to a specified level
	 * @param  {Object} location 	| object that contain latitude and longitude
	 * @param  {int} level 			| zoom value
	 */
	_google.panAndZoomTo = function( location, level ) {

		var _this = this;
		$.proxy( _google.zoomTo, _this, level )();
		$.proxy( _google.panTo, _this, location )();

	};



}( window.LC = window.LC || {}, jQuery ));


( function( LC, $ ) {

	"use strict";


	// some variables for making access easier.
	var _proto = LC.Components.Map.prototype,
		_baidu = _proto.providers.baidu;

	_baidu.defaults = {
		center: [ 35.447514, 110.764846 ],
		zoom: 5,
		zoomTo: 15,
		mapStyle: function() {

			/* eslint-disable quote-props */

			return [

				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": {
						"color": "#666666"
					}
				}, {
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": {
						"color": "#666666",
						"lightness": 89
					}
				}, {
					"featureType": "land",
					"elementType": "all",
					"stylers": {
						"color": "#eeeeee",
						"lightness": 5
					}
				}, {
					"featureType": "water",
					"elementType": "all",
					"stylers": {
						"color": "#cecece",
						"lightness": 27
					}
				}, {
					"featureType": "green",
					"elementType": "all",
					"stylers": {
						"hue": "#38761d",
						"lightness": 66,
						"saturation": -99
					}
				}, {
					"featureType": "manmade",
					"elementType": "all",
					"stylers": {
						"color": "#999999",
						"lightness": 71
					}
				}, {
					"featureType": "building",
					"elementType": "all",
					"stylers": {
						"hue": "#999999",
						"lightness": -7,
						"saturation": -95
					}
				}, {
					"featureType": "building",
					"elementType": "labels",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "subway",
					"elementType": "all",
					"stylers": {
						"color": "#666666",
						"weight": "0.3",
						"lightness": 60,
						"saturation": -100
					}
				}, {
					"featureType": "road",
					"elementType": "labels",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "road",
					"elementType": "labels.icon",
					"stylers": {
						"visibility": "off"
					}
				}, {
					"featureType": "highway",
					"elementType": "labels",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "highway",
					"elementType": "geometry.fill",
					"stylers": {
						"color": "#666666",
						"lightness": 97
					}
				}, {
					"featureType": "highway",
					"elementType": "geometry.stroke",
					"stylers": {
						"color": "#666666",
						"lightness": 68
					}
				}, {
					"featureType": "arterial",
					"elementType": "geometry",
					"stylers": {
						"color": "#eeeeee",
						"lightness": 98
					}
				}, {
					"featureType": "poi",
					"elementType": "labels",
					"stylers": {
						"visibility": "off"
					}
				}, {
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": {
						"color": "#666666"
					}
				}, {
					"featureType": "subway",
					"elementType": "labels",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "subway",
					"elementType": "labels.text.fill",
					"stylers": {
						"color": "#666666",
						"lightness": 18
					}
				}, {
					"featureType": "subway",
					"elementType": "labels.text.stroke",
					"stylers": {
						"color": "#eeeeee",
						"weight": "2.4",
						"lightness": 71
					}
				}, {
					"featureType": "administrative",
					"elementType": "labels.text.stroke",
					"stylers": {
						"color": "#eeeeee",
						"lightness": 84,
						"visibility": "on"
					}
				}, {
					"featureType": "railway",
					"elementType": "all",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "label",
					"elementType": "labels.icon",
					"stylers": {
						"visibility": "off"
					}
				}, {
					"featureType": "arterial",
					"elementType": "labels",
					"stylers": {
						"visibility": "on"
					}
				}, {
					"featureType": "arterial",
					"elementType": "labels.text.stroke",
					"stylers": {
						"lightness": 100,
						"visibility": "on"
					}
				}, {
					"featureType": "arterial",
					"elementType": "labels.text.fill",
					"stylers": {
						"lightness": 49
					}
				}, {
					"featureType": "boundary",
					"elementType": "geometry.stroke",
					"stylers": {
						"color": "#ffffff"
					}
				}, {
					"featureType": "boundary",
					"elementType": "geometry.fill",
					"stylers": {
						"color": "#cccccc",
						"lightness": 1
					}
				}
			];

			/* eslint-enable quote-props */

		}
	};

	_baidu.setDefaults = function() {

		var _this = this;

		_this.options = $.extend( true, {}, _baidu.defaults, _this.options );

	};

	/**
	 * method for creating the map inside the
	 * correct element on the page
	 *
	 * @param  {Object} _this 	| instance of the LC.Map component
	 * @param  {$Object} $el 	| element we want to apply the map on
	 */
	_baidu.createMap = function() {

		var _this = this,
			$map = _this.$map;

		// extend the default options with google default options
		$.proxy( _baidu.setDefaults, _this )();

		_this.map = new BMap.Map( $map[ 0 ], {

			enableMapClick: _this.options.clickableIcons

		} );

		$.proxy( _baidu.setupMap, _this )();

	};

	/**
	 * setup the map center and the zoom level
	 * @param  {Object} _this 	| instance of the LC.Map component
	 */
	_baidu.setupMap = function() {

		var _this = this,
			center = new BMap.Point( _this.options.center[ 1 ], _this.options.center[ 0 ] ),
			zoomLevel = _this.options.zoom,
			mapStyle = _this.provider.defaults.mapStyle();

		_this.map.centerAndZoom( center, zoomLevel );
		_this.map.setMapStyle( {
			styleJson: mapStyle
		});

	};

	_baidu.createMarker = function( location, iconObject ) {

		var _this = this,
			marker,
			icon,
			markerIcon = _.extend( {}, this.options.marker, iconObject ),
			markerSize = new BMap.Size( markerIcon.size.x, markerIcon.size.y ),
			iconOffset = new BMap.Size( markerIcon.anchor.x, markerIcon.anchor.y ),
			center = new BMap.Point( location.longitude, location.latitude );

		icon = new BMap.Icon( markerIcon.url, markerSize, {
			offset: iconOffset
		} );

		marker = new BMap.Marker( center, {

			icon: icon

		} );

		_this.map.addOverlay( marker );

		return marker;

	};

	_baidu.createInfoWindow = function( content, infoObject ) {

		var _this = this,
			infoWindow,
			infoSetting = _.extend( {}, _this.options.infoWindow, infoObject );

		infoWindow = new BMap.InfoWindow( content, {

			width: infoSetting.maxWidth,
			height: infoSetting.maxheight

		});

		return infoWindow;

	};

	_baidu.bindClickMarkerEvent = function( infoWindow, marker, callback ) {

		var _this = this;

		marker.addEventListener( "click", function() {

			$.proxy( callback, _this, infoWindow, marker )();

		} );

	};

	/**
	 * method to open a specific info window at a marker's
	 * position on the map.
	 * @param  {object} infoWindow | object which comes from _this.infoWindows;
	 * @param  {object} marker     | object which comes from _this.markers;
	 * @return {object}            | returns the infoWindow which was opened.
	 */
	_baidu.openInfoWindow = function( infoWindow, marker ) {

		var _this = this,
			position;

		// baidu needs to get position from
		// a set of coords, which we gather from the marker.
		position = new BMap.Point( marker.point.lng, marker.point.lat );

		_this.map.openInfoWindow( infoWindow, position );

		$.proxy( _baidu.styleInfoWindow, _this )();

		return infoWindow;

	};

	_baidu.styleInfoWindow = function() {

		var _this = this,
			$infoWindow,
			$content;

		$infoWindow = _this.$map
			.find(".BMap_pop")
			.addClass("info-window");

		$content = $( ".BMap_bubble_content" ).parent();

		$infoWindow
			.find("*")
			.not( $content )
			.not( $( ".BMap_bubble_content, .BMap_bubble_content *" ) )
			.addClass( "hide" );

		$infoWindow
			.find( $content )
			.addClass( "info-window__content" );

	};

	/**
	 * close the infoWindow which is passed as parameter,
	 * but baidu does not need to loop, like google, because
	 * it seems to only allow one open window at a time.
	 */
	_baidu.closeInfoWindow = function() {

		// https://goo.gl/PXeiI5
		this.map.closeInfoWindow();

	};

	/**
	 * method for pan the map to the desired location
	 * @param  {Object} location 	| object that contain latitude and longitude
	 */
	_baidu.panTo = function( location ) {

		var center;

		center = new BMap.Point( location.longitude, location.latitude );

		this.map.setCenter( center );

	};

	/**
	 * method for zoom in the map
	 * @param  {int} level 		| zoom value
	 */
	_baidu.zoomTo = function( level ) {

		var _this = this;

		level = level || _this.provider.defaults.zoomTo;
		_this.map.setZoom( level );

	};

	/**
	 * center the map on a specific location,
	 * and zoom to a specified level
	 * @param  {Object} location 	| object that contain latitude and longitude
	 * @param  {int} level 			| zoom value
	 */
	_baidu.panAndZoomTo = function( location, level ) {

		var _this = this,
			center;

		center = new BMap.Point( location.longitude, location.latitude );

		level = level || _this.provider.defaults.zoomTo;
		_this.map.centerAndZoom( center, level );

	};



}( window.LC = window.LC || {}, jQuery ));

 //# sourceURL=lc-map.js
